
import { defineComponent, PropType, computed, toRefs, ref, watch } from 'vue-demi';
import accountState from '@/store/modules/account/index';
import { NotiFromType, NotiActionType } from '@/const/notification';
import { useRouter } from '@/router/use-router/index';
import BytedIconCloseSmall from '@byte-design/vue-icons/icons/CloseSmall';

import { useNotification } from './hooks/index';
import PerfNotificationBody from './perf-notification-body.vue';

const name = 'PerfNotificationDetailAbTest';
export default defineComponent({
  name,
  components: { BytedIconCloseSmall, PerfNotificationBody },
  props: {
    notiList: {
      type: Array as PropType<any>,
      default: () => [{ id: '' }],
      required: true,
    },
    from: {
      type: String,
      default: NotiFromType.notification,
    },
  },
  setup(props) {
    const { handleMoreBtnVisible, gotoNewBilling, closeNotification } = useNotification();

    const router = useRouter();
    const showMore = ref(false); // Expand & Collapse copywriting in banner
    const ifMore = ref(true);
    const notiItem = ref(null); // Template ref
    const { notiList } = toRefs(props);
    const reactiveState = ref({
      showMore,
    });
    const aadvid = computed(() => accountState.getters.adverId(accountState.state));
    const newList = ref(notiList.value);
    const notiListLength = computed(() => newList.value.length);
    watch(notiList, newlyLoaded => {
      newList.value = newlyLoaded;
    });

    function expandAndCollapse() {
      ifMore.value = !ifMore.value;
    }

    function handleRedirect(cta: string) {
      router.push({
        name: cta,
      });
    }
    function handleClose(currentNoti, notiIndex): void {
      closeNotification(aadvid.value, currentNoti, true, notiIndex); // add to storage
      // hide the selected noti and update list of notifications to show
      newList.value = newList.value.filter(noti => noti?.id !== currentNoti?.id);
    }

    return {
      fromDashboard: props.from === NotiFromType.dashboard,
      NotiActionType,
      notiListLength,
      handleClose,
      handleRedirect,
      handleMoreBtnVisible,
      expandAndCollapse,
      notiItem,
      showMore,
      ifMore,
      gotoNewBilling,
      reactiveState,
      newList,
    };
  },
});
